import React from 'react';
import { styled } from '@mui/material/styles';
import IconButton from '../../../IconButton';
import Typography from '../../../Typography';
import { Close } from '../../../Icons/Core';
import Box from '../../../Box';
import { ArrowBack } from '@mui/icons-material';
const StyledDiv = styled('div')(({ theme }) => ({
    paddingLeft: theme.palette.space.container.default,
    // TODO: Talk to Ann about the close icon not aligning with the list item icons
    paddingRight: theme.palette.space.container.default,
    height: '100%'
}));
const StyledNavigationSubmenu = styled(Box)(({ theme }) => {
    return {
        display: 'flex',
        flexDirection: 'column',
        width: theme.palette.navigation.container.secondary.width,
        height: '100vh',
        gap: theme.palette.navigation.container.secondary.spaceBetween,
        background: theme.palette.menuItem.background.color,
        padding: `0 ${theme.palette.navigation.container.secondary.padding} ${theme.palette.navigation.container.secondary.padding}`
    };
});
const StyledTitle = styled((props) => React.createElement(Typography, Object.assign({ component: "div", variant: "h3" }, props)))(({ theme }) => {
    return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: `${theme.palette.space.container.default} ${theme.palette.space.container.default} ${theme.palette.space.container.dense} ${theme.palette.space.container.default}`,
        '& .title-container': {
            display: 'flex',
            alignItems: 'center',
            gap: theme.palette.space.container.default
        }
    };
});
export const NavigationSubmenu = ({ title, onClose, children, handleBack }) => {
    return (React.createElement(StyledNavigationSubmenu, null,
        React.createElement(StyledTitle, null,
            React.createElement("div", { className: "title-container" },
                handleBack && (React.createElement(IconButton, { bdsSize: "input", onClick: handleBack, "data-testid": "back-button" },
                    React.createElement(ArrowBack, null))),
                title),
            React.createElement(IconButton, { bdsSize: "input", onClick: onClose, "data-testid": "close-button" },
                React.createElement(Close, null))),
        React.createElement(StyledDiv, null, children)));
};
//# sourceMappingURL=NavigationSubmenu.js.map